import React from "react";
import { updatePrefferPartner } from "../../api/PrefferPartner";
import Swal from "sweetalert2";

const EditPrefferPartner = ({ prefferPartner, onSuccess }) => {
  const [prefferPartnerDetails, setPrefferPartnerDetails] = React.useState({
    id: "",
    partner_name: "",
  });

  React.useEffect(() => {
    setPrefferPartnerDetails({
      id: prefferPartner?._id,
      partner_name: prefferPartner?.partner_name,
    });
  }, [prefferPartner]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const response = updatePrefferPartner(prefferPartnerDetails);
    response
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            title: "Preffer Partner Updated!",
            text: "You have successfully updated a preffer partner!",
            icon: "success",
            draggable: true,
            timer: 1000,
          });
          onSuccess(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <form className="text-left" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="exampleInputPartnerName">Partner Name</label>
          <input
            type="text"
            className="form-control"
            name="partner_name"
            value={prefferPartnerDetails.partner_name}
            onChange={(e) =>
              setPrefferPartnerDetails({
                ...prefferPartnerDetails,
                id: prefferPartnerDetails?.id,
                partner_name: e.target.value,
              })
            }
          />
        </div>
        <button type="submit" className="btn btn-primary text-right">
          Save
        </button>
      </form>
    </>
  );
};

export default EditPrefferPartner;
